"use client";

import { Button } from "@mui/material";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Product from "@/app/models/Product";

const btnCommonSx = {
    borderRadius: '50px', // Makes the button rounder
    padding: '12px 24px'
}

const  WhatsAppButton: React.FC<{ product: Product }> = ({ product }) => {
    const productUrl: string = `https://allpromo.mu/products/${product.uniqueName}`;
    const whatsappMessage = encodeURIComponent(productUrl);
    const whatsappLink = `https://wa.me/23055111603?text=${whatsappMessage}`;

    return (

        <div>
            {
                (product.stock > 0) ? (
                    <Button
                    variant="contained"
                    sx={{
                        mt: 4,
                        backgroundColor: '#fff', // WhatsApp Green color
                        '&:hover': {
                            backgroundColor: '#128C7E', // Darker WhatsApp Green for hover effect
                        },
                        border: 'solid 3px',
                        fontWeight: 'bold',
                        fontSize: '23px',
                        color: '#25D366'
                        , ...btnCommonSx
                    }}
                    fullWidth
                    startIcon={<WhatsAppIcon style={{ fontSize: '32px'}}/>}
                    onClick={() => window.open(whatsappLink, "_blank")}
                    >
                        Commander
                    </Button>
                ) : ( <div className="text-red-500 font-bold">Rupture de stock</div> )
            }
            
        </div>
     
    );
}

export default WhatsAppButton;
